import {
  __internallyCacheRequestResult,
  __internallyPrepareRequest,
  BASE_API_REQ,
  DELETE,
  GET,
  POST,
  PUT,
} from "../utils/base.api.legacy";

type OnCompletedData<T> = { data: T; message: string; token: string };

type API_GENERATOR<InoutType extends Partial<BASE_API_REQ>, ReturnType> = {
  onCompleted: (params: OnCompletedData<ReturnType>) => void;
  onError: (err?: any) => void;
} & Partial<InoutType & BASE_API_REQ>;

type ApiMethods = "get" | "put" | "post" | "delete";

const API_METHOD = {
  get: GET,
  put: PUT,
  post: POST,
  delete: DELETE,
};

type bypassCacheParams = { bypassCache: boolean };
export function generateAPI<
  InputType extends Partial<BASE_API_REQ>,
  ReturnType,
>(
  apiMethod: ApiMethods,
  route: string,
  // cacheResultToRoute is used to save the result of the api call
  cacheResultToRoute?: string,
) {
  return async (
    { onCompleted, onError, ...rest }: API_GENERATOR<InputType, ReturnType>,
    bypassCacheParams?: bypassCacheParams,
  ) => {
    try {
      const data = await API_METHOD[apiMethod]<ReturnType>(
        {
          ext: route,
          ...rest,
        },
        !bypassCacheParams?.bypassCache, // !bypassCache === useCache
      );
      if (data.error) {
        onError(data.error);
        return;
      }

      if (data.statusCode === 200 || data.statusCode === 201) {
        // update the result in cache for subsequent gets
        if (cacheResultToRoute) {
          const reqUrl = __internallyPrepareRequest({
            ext: cacheResultToRoute,
          });
          __internallyCacheRequestResult(reqUrl, data);
        }
        onCompleted({
          data: data.payload,
          token: data.token!,
          message: data.message,
        });
        return;
      }

      if (data.statusCode >= 400 || data.statusCode !== 200) {
        onError(data.message);
        return;
      }
    } catch (error: any) {
      onError(error?.message);
    }
  };
}
